import {configClient} from '../../../../config/app/config-client';

/**
 * Global styling used by CIModal
 */
require('./modal-animations.scss');

/**
 * Length of time until modal hides, in form usable by CSS props
 */
const timeout = `${configClient.animations.modalHideLengthMs}ms`;

/**
 * Styles applied to CIModal
 */
export const styleVals = {
    ciModalBoxShadow: `2px 2px 3px rgba(0, 0, 0, 0.2)`,
    xButtonTopRightPos: 13,
    overflow: 'hidden',
};

/**
 * Animations used for entrance and exit of CIModal component
 */
export const animations = {
    zoomEnter: {animation: `modal-zoom-enter both ${timeout}`},
    fadeEnter: {animation: `modal-fade-enter both ease-in ${timeout}`},
    fadeLeave: {animation: `modal-fade-leave both ease-in ${timeout}`},
    zoomLeave: {animation: `modal-zoom-leave both ${timeout}`},
};

/**
 * Initial props used in the CIModal component
 */
export const defaultCIModalPropVals = {
    underlayProps: {},
    dialogId: `#cimodal-inner-content-area-wrapper`,
    clickOutsideExits: true,
    escapeExits: false,
    underlayColor: `rgba(0,0,0,0.5)`,
    includeDefaultStyles: true,
    focusTrapPaused: false,
    scrollDisabled: true,
    applicationNodeId: `app`,
};
